import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
const STANDARD_BG = 'bg.webp';
const css = {
  mainBox: (center, height) => ({
    position: 'relative',
    minHeight: `${height}vh`,
    overflow: 'auto',
    alignContent: center && 'center',
  }),
  imgBg: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: -1,
  },
  transparentLayer: (transparency) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: transparency ? '#00000080' : '',
    overflow: 'auto',
    zIndex: -1,
  }),
  childrenBox: (boxWidth) => ({ width: boxWidth, margin: '0 auto' }),
};

/**
 * Background image, receive the img src and it can include the black transparent layer or not
 * @returns {JSX.Element}
 */
const Background = ({
  children,
  bg = STANDARD_BG,
  transparency = true,
  center = false,
  height = 100,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const boxWidthMd = isMd ? '60%' : '40%';
  const boxWidth = isMobile ? '90%' : boxWidthMd;

  return (
    <Box sx={css.mainBox(center, height)}>
      <Box component="img" src={`/images/common/${bg}`} alt="background" sx={css.imgBg} />
      {/* Dark transparent layer */}
      <Box sx={css.transparentLayer(transparency)} />
      {/* Main content box */}
      <Box sx={css.childrenBox(boxWidth)}>{children}</Box>
    </Box>
  );
};
Background.propTypes = {
  children: PropTypes.element.isRequired,
  bg: PropTypes.string,
  transparency: PropTypes.bool,
  center: PropTypes.bool,
  height: PropTypes.number,
};
export default Background;
